import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderChoiceItem } from './header-choice-item';

@Component({
  selector: 'def-header-choices',
  templateUrl: './header-choices.component.html',
  styleUrls: ['./header-choices.component.scss'],
})
export class HeaderChoicesComponent {
  @Input() title: string;
  @Input() borderSide?: 'left' | 'right' = 'right';
  @Input() choices: HeaderChoiceItem[];

  constructor(private router: Router) {
  }

  get isHighlighted(): boolean {
    return this.choices.some(choice => this.router.url.includes(choice.link));
  }
}
